// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2yeNg","search":"Settings_search__2-mvb","filter":"Settings_filter__2oK52"};